import { Container, Grid, Typography, Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useAuthContext } from 'src/auth/hooks';
import { useSettingsContext } from 'src/components/settings';
import { getProducts } from 'src/services/products.service';
import ProductCard from 'src/components/products-card/product-card';
import AddProductCard from 'src/components/products-card/add-product-card';

export default function ClinicProductsView() {
  const navigate = useNavigate();
  const settings = useSettingsContext();
  const { user } = useAuthContext();
  const [cardData, setCardData] = useState([]);

  useEffect(() => {
    getProducts(user.clinic_id )
      .then((res) => {
        const products = res || [];


        const tempCardData = products.map((product) => ({
          id: product.id,
          product_name: product.product_name,
          product_code: product.product_code,
          description: product.description,
          price: product.price,
          quantity: product.quantity,
          category: product.category,
          best_before: product.best_before,
          is_active: product.is_active,
          image_url: product.image_url || [],
        }));
        setCardData(tempCardData);
      })
      .catch((error) => {
      });
  }, [user.clinic_id]);

  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'} sx={{ marginY: '24px' }}>
      <Grid container spacing="18px">
        <Grid item lg={4} xl={3} xs={6}>
          <AddProductCard />
        </Grid>
        {cardData.map((cardDetails) => (
          <Grid item xs={6} key={cardDetails.id} lg={4} xl={3}>
            <ProductCard cardDetails={cardDetails} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
